module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc16-80919f9904a6084f60317adfd4fd234b.jpg";